import { GetPackageActivityModel } from "@factory/model/query-model-package-activity";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { packageActivityFormDefault } from "./form.default";
import { PackageActivityFormSchema } from "./form.rule";

export const useFormDefaultPackageActivity = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPackageActivityModel | undefined) => {
    return !cachedValue
      ? packageActivityFormDefault
     : ({
        package: cachedValue.package,
        activity: cachedValue.activity,
      } as PackageActivityFormSchema);
  };

  return {
    getDefault,
  };
};
